import { useMemo } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_TIME_TO_RECOVERY_AVERAGE } from "./gql";

type UseGetTimeToRecoveryAverageProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetTimeToRecoveryAverage = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetTimeToRecoveryAverageProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_TIME_TO_RECOVERY_AVERAGE,
    {
      variables: {
        input: {
          startTime: startTimeUnix,
          endTime: endTimeUnix,
          timezone: null,
        },
      },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend value in seconds, undefined when no data yet
  const averageSeconds = useMemo(() => {
    return (
      data?.metricsRange?.averageTimeToRecoveryValue?.[0]?.value ??
      previousData?.metricsRange?.averageTimeToRecoveryValue?.[0]?.value
    );
  }, [data, previousData]);

  return {
    averageSeconds,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetTimeToRecoveryAverage;
